// extracted by mini-css-extract-plugin
module.exports = {"shadowed":"About_shadowed__fyXNJ","pink":"About_pink__1UdUC","green":"About_green__3CngP","skills":"About_skills__pxTAq"};